import { Injectable, inject } from '@angular/core';
import { WatermarkService } from '@leafpoda/hiplanet/services';
import { StatesService } from 'src/app/core/store/states.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class WaterMarkService {
  private ws = inject(WatermarkService);
  private statesService = inject(StatesService);

  // 用户信息
  userInfo: UserInfo = this.statesService.userInfo$.getValue();

  public watermarkInit() {
    // 非生产（本地开发 / ng serve）不显示水印 —— 本地连的是内部环境，水印只会碍事。
    if (!environment.production) {
      return;
    }

    // 🔴 演示环境下水印固定写「演示环境」，不写登录名。
    //    演示账号是所有人共用的一个（realname = 演示账号），写上去没有信息量；
    //    而「演示环境」这四个字会跟着每一张截图走 —— 那才是需要的效果。
    const demo = this.statesService.environmentInfo$.getValue()?.demo === true;
    const content = demo ? '演示环境' : this.userInfo?.realname;

    if (content) {
      this.ws.createWatermark({
        content,
        width: 150,
        height: 100,
        yValue: 15,
        fillStyle: 'rgba(0, 0, 0, 0.04)',
        zIndex: 2000,
      });
    }
  }
}
